import { useState } from "react";

/**
 * BrandLogo — progressive-fallback brand logo.
 * If brand.custom_logo_url is set (uploaded by admin), use it at full-square fill (object-cover).
 * Otherwise, fall through: brand.logo_url → DuckDuckGo ip3 → UI-Avatars (object-contain).
 */
const SIZE_MAP = {
    sm: { maxWidth: "82%", maxHeight: "82%" },
    md: { maxWidth: "92%", maxHeight: "92%" },
    lg: { maxWidth: "96%", maxHeight: "96%" },
    xl: { maxWidth: "98%", maxHeight: "98%" },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

function absUrl(u) {
    if (!u) return u;
    if (u.startsWith("/api/uploads/") || u.startsWith("/uploads/")) return `${BACKEND_URL}${u}`;
    return u;
}

export default function BrandLogo({ brand, size = "md", className = "", style = {} }) {
    const [idx, setIdx] = useState(0);
    const custom = brand.custom_logo_url;
    if (custom) {
        return (
            <img
                src={absUrl(custom)}
                alt={brand.brand_name}
                loading="lazy"
                className={`w-full h-full object-cover ${className}`}
                style={style}
            />
        );
    }
    const domain = brand.logo_domain || "";
    const sources = [
        brand.logo_url,
        domain ? `https://icons.duckduckgo.com/ip3/${domain}.ico` : null,
        `https://ui-avatars.com/api/?name=${encodeURIComponent(brand.brand_name)}&background=0B1437&color=C9A959&bold=true&size=256&font-size=0.40`,
    ].filter(Boolean);
    const src = sources[idx] || sources[sources.length - 1];
    const sizeStyle = SIZE_MAP[size] || SIZE_MAP.md;

    return (
        <img
            src={absUrl(src)}
            alt={brand.brand_name}
            loading="lazy"
            onError={() => setIdx((i) => Math.min(i + 1, sources.length - 1))}
            className={`object-contain ${className}`}
            style={{ ...sizeStyle, ...style }}
        />
    );
}
